// collection-list-menu-------------
$(document).ready(function() {
  $('.collection-list li a').on('click', function(e) {
    var target = $(this).attr("href");
    $('html, body').stop().animate({
        scrollTop: $(target).offset().top
    }, 600, function() {
      location.hash = target;
    });
    return false;
  });

  /* sticky header */
  let lastScroll = 0;
  function sticky_header(){
    let header_hegith = $('.header').innerHeight();
    let scroll = $(window).scrollTop();
    if (scroll > header_hegith && scroll > lastScroll) {
        $('.header').addClass('sticky-header');
    } else if (scroll < lastScroll) {
        $('.header').removeClass('sticky-header');
    }
    lastScroll = scroll;
  }

  $(() => {
    sticky_header();
  });

  // window.onload = () => {
  //   sticky_header();
  //   $('.header').addClass('headerUp');
  // };

  window.onscroll = () => {
  	sticky_header();
  };

  window.onresize = (event) => {
    sticky_header();
  };

//   $(window).scroll(function() {
//     var scroll = $(window).scrollTop();
//    if ( $("body").hasClass('template-index') ){
//     var header = $('.header');
//     var hieghtThreshold = $('.slideshow').offset().top;
//     var hieghtThreshold_end  = $(".slideshow").offset().top +$(".slideshow").height() - 250;
//     var headerHeight  = $(".header").offset().top +$(".header").height() ;
//     var scroll2 = $(window).scrollTop();
//     if (scroll2 >= hieghtThreshold && scroll2 <=  hieghtThreshold_end ) {
//       header.addClass('headerUp');
//     } else {
//       header.removeClass('headerUp');
//     }
//   }
// });
  
 // <!-- Initialize Swiper -->
  if($(window).width() <= 798 ){
    var swiper = new Swiper(".prod-grid-swap", {
      slidesPerView: 1,
      pagination: {
        el: ".swiper-pagination",
      }
    }); 
  }

});

var lastScroll = 0;
$(window).scroll(function() {
  var scrollDistance = $(window).scrollTop();
  $('.featured-coll').each(function(i) {
      if ($(this).position().top <= scrollDistance) {
          $('.collection-list li a.active').removeClass('active');
          $('.collection-list li a').eq(i).addClass('active');
      }
  });
}).scroll();